
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsListProjects.vue";
  import UploadDocument from "@/components/documents/UploadDocumentResources.vue";
  import ProjectDocumentAccessScope from "@/components/documents/projects/ProjectDocumentAccessScope.vue";
  import Roles from "@/entities/Roles";
  import { Document, User } from "@/generated/graphql";
  import CardInfoChip from "@/components/card/CardInfoChip.vue";
  import DocumentProjectAccessScope from "@/data/documentAccessScope/DocumentProjectAccessScope";
  import { selfVisible } from "@/data/badgesText";

  @Component({
    components: {
      CardInfoChip,
      ProjectDocumentAccessScope,
      SearchableDocumentsList,
      UploadDocument,
    },
  })
  export default class Documents extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly projectId!: string;
    @Prop({ type: Boolean, default: false }) readonly projectCompleted!: boolean;
    @Prop({ type: String, required: true }) readonly userRole!: string;

    get query(): Object {
      return {
        document_projects: {
          project_id: {
            _eq: this.$route.params.id,
          },
        },
      };
    }

    getScope(document: Document): DocumentProjectAccessScope {
      return document.document_projects[0].access_scope as DocumentProjectAccessScope;
    }

    getBadgeColor(document: Document): "gray" | "green" {
      const accessScope = this.getScope(document);

      if (accessScope === DocumentProjectAccessScope.ADMIN) {
        return "green";
      }

      return "gray";
    }

    getAccessScope(document: Document): string {
      const accessScope = this.getScope(document);
      const contractorsCount = document.document_contractor_accesses_aggregate.aggregate?.count ?? 0;
      const contractorsString = contractorsCount == 1
        ? "contractor"
        : "contractors"

      switch (accessScope) {
        case DocumentProjectAccessScope.SELECTED:
          return `Shared with Admin, Manager, and ${contractorsCount} ${contractorsString}`;
        case DocumentProjectAccessScope.ALL:
          return `Shared within the project`;
        case DocumentProjectAccessScope.MANAGEMENT:
          return 'Shared with Admin and Manager';
        case DocumentProjectAccessScope.ADMIN:
          return selfVisible;
        default:
          return "";
      }
    }

    accessScopeEditable(uploadedByUserId: string): boolean {
      if (this.userRole === Roles.ADMIN) {
        return true;
      }

      return uploadedByUserId === this.currentUser.id;
    }
  }
